import { SVGProps } from "react";

export function RewardsIllustration(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width={88} height={88} viewBox="0 0 88 88" fill="none" {...props}>
      <circle cx={44} cy={44} r={36} fill="#DEDFE0" opacity={0.2} />
      <path
        fill="#3E8D96"
        fillRule="evenodd"
        d="M51.955 40H20a2 2 0 0 0-2 2v30a2 2 0 0 0 2 2h38a2 2 0 0 0 2-2V47.816a1.515 1.515 0 0 1-.6-.37L51.956 40ZM60 43.738V42a2 2 0 0 0-2-2h-1.738L60 43.738Z"
        clipRule="evenodd"
      />
      <path fill="#AACFD3" d="M34 40h10v34H34z" />
      <rect
        width={42}
        height={8}
        x={50.657}
        y={24}
        fill="#3E8D96"
        rx={2}
        transform="rotate(45 50.657 24)"
      />
      <path
        fill="#AACFD3"
        d="M69.145 31.84c.277 3.634-4.227 6.94-4.227 6.94s-4.953-2.584-5.23-6.218c-.278-3.633 4.226-6.94 4.226-6.94s4.954 2.584 5.231 6.218Z"
      />
      <path
        fill="#AACFD3"
        d="M70.916 43.053c-3.632.288-6.953-4.205-6.953-4.205s2.569-4.962 6.202-5.251c3.632-.289 6.953 4.205 6.953 4.205s-2.569 4.962-6.202 5.25Z"
      />
      <path
        fill="#AACFD3"
        d="m61.654 34.827-5.768 5.768 7.072 7.07 5.768-5.768-7.072-7.07Z"
      />
      <path
        fill="#AACFD3"
        d="M38.683 36.333a.852.852 0 0 1-.625-.258.851.851 0 0 1-.258-.625v-.65a3.697 3.697 0 0 1-1.367-.633c-.377-.29-.683-.695-.916-1.217a.802.802 0 0 1 .016-.658.858.858 0 0 1 .517-.475.764.764 0 0 1 .633.008c.211.094.384.253.517.475.189.3.417.525.683.675.267.15.595.225.984.225.433 0 .78-.095 1.041-.283.261-.19.392-.462.392-.817 0-.333-.128-.611-.383-.833-.256-.223-.75-.445-1.484-.667-1.077-.322-1.814-.73-2.208-1.225-.394-.494-.592-1.042-.592-1.642 0-.755.22-1.344.659-1.766.439-.423.941-.7 1.508-.834v-.583c0-.245.086-.453.258-.625a.852.852 0 0 1 .625-.258c.245 0 .453.086.625.258.173.172.259.38.259.625v.583c.377.056.733.198 1.066.425.334.228.611.509.834.842.133.2.152.422.058.667A.935.935 0 0 1 41 27.6a.833.833 0 0 1-.592.017 1.437 1.437 0 0 1-.591-.4 1.384 1.384 0 0 0-.467-.334 1.618 1.618 0 0 0-.65-.116c-.433 0-.758.094-.975.283-.217.189-.325.394-.325.617 0 .322.13.575.392.758.26.183.864.42 1.808.708.8.234 1.417.609 1.85 1.125.433.517.639 1.12.617 1.809-.023.866-.264 1.516-.725 1.95-.461.433-1.053.716-1.775.85v.583a.851.851 0 0 1-.259.625.851.851 0 0 1-.625.258Z"
      />
      <path
        fill="#AACFD3"
        d="M26.683 31.333a.852.852 0 0 1-.625-.258.851.851 0 0 1-.258-.625v-.65a3.697 3.697 0 0 1-1.367-.633c-.377-.29-.683-.695-.916-1.217a.802.802 0 0 1 .016-.658.858.858 0 0 1 .517-.475.764.764 0 0 1 .633.008c.211.094.384.253.517.475.189.3.417.525.683.675.267.15.595.225.984.225.433 0 .78-.095 1.041-.283.261-.19.392-.462.392-.817 0-.333-.128-.611-.383-.833-.256-.223-.75-.445-1.484-.667-1.077-.322-1.814-.73-2.208-1.225-.394-.494-.592-1.042-.592-1.642 0-.755.22-1.344.659-1.766.439-.423.941-.7 1.508-.834v-.583c0-.245.086-.453.258-.625a.852.852 0 0 1 .625-.258c.245 0 .453.086.625.258.173.172.259.38.259.625v.583c.377.056.733.198 1.066.425.334.228.611.509.834.842.133.2.152.422.058.667A.935.935 0 0 1 29 22.6a.833.833 0 0 1-.592.017 1.437 1.437 0 0 1-.591-.4 1.384 1.384 0 0 0-.467-.334 1.618 1.618 0 0 0-.65-.116c-.433 0-.758.094-.975.283-.217.189-.325.394-.325.617 0 .322.13.575.392.758.26.183.864.42 1.808.708.8.234 1.417.609 1.85 1.125.433.517.639 1.12.617 1.809-.023.866-.264 1.516-.725 1.95-.461.433-1.053.716-1.775.85v.583a.851.851 0 0 1-.259.625.851.851 0 0 1-.625.258Z"
      />
      <defs />
    </svg>
  );
}
